<template>
    <div class="other-act">
        <div class="left-box">
            <h4 class="title">吃喝玩乐</h4>
            <div class="item-box" v-for="(item, index) in dataEat" :key="index" @click="jumpDetail(item)">
                <img class="img-box" :src="item.icon" alt="">
                <h4 class="tit">{{item.title}}</h4>
            </div>
        </div>
        <div class="right-box">
            <h4 class="title">超值补贴</h4>
            <div class="item-box" v-for="(item, index) in dataPlay" :key="index" @click="jumpDetail(item)">
                <img class="img-box" :src="item.icon" alt="">
                <h4 class="tit">{{item.title}}</h4>
            </div>
        </div>
    </div>
</template>

<script>
import {  Toast, Icon } from 'vant';
import { toPage, randomString } from "@/utils/tools";

export default {
    name: 'otherAct',
    props: {
        dataEat: {
            type: Array,
            default: () => []
        },
        dataPlay: {
            type: Array,
            default: () => []
        }
    },
    components: {
        [Icon.name]: Icon,
    },
    data() {
        return {
        }
    },
    mounted() {
        const allData = this.dataEat.concat(this.dataPlay)
        if (allData.length > 0) {
            let rightNames = []
            allData && allData.forEach((i)=> {
                rightNames.push(i.title)
            })
            this.$emit('setTrack', {
                action: 'students_subrights_show',
                label: '学生附加权益曝光',
                value: {"channel":"学生专区","scene":"公共","rights": rightNames}
            })
        }
    },
    methods: {
        jumpDetail(info) {
            this.$emit('setTrack', {
                action: 'students_subrights_click',
                label: '学生附加权益点击',
                value: {"channel":"学生专区","scene":"公共","rights": info.title}
            })
            toPage(info.jumpUrl)
        }
    }
}
</script>

<style lang="less" scoped>
.other-act {
    display: flex;
    // background: rgba(0,176,137,1);
    padding: 0 12px;
    margin-bottom: 12px;
    .left-box, .right-box {
        flex: 1;
        background: #FFFFFF;
        border-radius: 8px;
        padding: 12px;
    }
    .left-box {
        margin-right: 7px;
    }
    .title {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        margin-bottom: 12px;
    }
    .item-box {
        // width: 50%;
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        &:last-child {
            margin-bottom: 0;
        }
        .img-box {
            width: 32px;
            height: 32px;
            border-radius: 4px;
            margin-right: 8px;
        } 
        .tit {
            max-width: 106px;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis
        }
        
    }
}
</style>>
